var map = {
	"./music-instructions.json": 4587,
	"./music-library-intro2024.json": 4588,
	"./music-library-launch2024.json": 4589,
	"./music-progression.json": 4590,
	"./startSourcesAdvanced.json": 4591,
	"./startSourcesSimple.json": 4592,
	"./startSourcesSimple2.json": 4593,
	"./startSourcesTracks.json": 4594
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4353;